import React from 'react';
import { ExampleImg } from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { DownloadFile, Margin } from '@helpers';
import { getImage } from "gatsby-plugin-image";

export const MediaStyle = ({getPng, getZip, t}) => {
    return (
      <PageWrapper darkMode={false}>
        <Container paddingTop='57px' marginLeft='102px' paddingBottom='88px'>
          <Text width='575px' paddingBefforeText="45px" paddingAffterText="70px">
            <h1>{t("Marketing media style")}</h1>
            <p>
              {t("The design of marketing materials should focus on minimalism, brand colors, clear layout, light backgrounds, and distinct geometry of shapes.")}
            </p>
          </Text>
          <ExampleImg image={getImage(getPng("media_example_1"))} alt="example" />
          <Margin marginTop="40px" marginBottom="40px">
            <ExampleImg image={getImage(getPng("media_example_2"))} alt="example" />
          </Margin>
          <ExampleImg image={getImage(getPng("media_example_3"))} alt="example" />
          <FlexDiv marginTop="57px">
            <div>
              <DownloadFile fileName='example_1' file={getZip("example_1")}/>
              <DownloadFile fileName='example_2' file={getZip("example_2")}/>
            </div>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
